import React, { useState, useEffect } from 'react';
import IconButton from '@fuww/components/src/Button/IconButton';
import Snackbar from '@fuww/components/src/Snackbar';
import Alert from '@fuww/components/src/Alert';
import ClearIcon from '@fuww/components/src/Icons/Clear';

const ErrorSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const displaySnackbar = (event: CustomEvent<string>) => {
    const errorMessage = event.detail;
    setMessage(errorMessage);
    setOpen(true);
  };

  useEffect(() => {
    window.addEventListener(
      'displaySnackbar', displaySnackbar as EventListener,
    );
    return () => {
      window.removeEventListener(
        'displaySnackbar', displaySnackbar as EventListener,
      );
    };
  }, []);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        elevation={6}
        variant="filled"
        severity="error"
        action={(
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              setOpen(false);
            }}
          >
            <ClearIcon fill="#fff" />
          </IconButton>
        )}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbar;
